import { ApiService } from 'networking/api-service';
import { API_ROUTES } from 'networking/api-routes';
import { AlbumMemberRole } from 'common/enums';

const mapInviteInfo = (raw: AlbumInviteInfoRaw): AlbumInviteInfo => ({
  email: raw.email,
  name: raw.name,
  role: raw.role,
  status: raw.status,
  albumId: raw.album_id,
  albumName: raw.album_name,
  inviterName: raw.inviter_name,
  vaultId: raw.vault_id,
});

class AlbumInviteController {
  // Invite someone (viewer/contributor) to an album by email.
  static async inviteToAlbum({
    albumId,
    email,
    name,
    role,
  }: {
    albumId: number;
    email: string;
    name?: string;
    role: AlbumMemberRole;
  }): Promise<AlbumMemberType> {
    const response = await ApiService.post<AlbumMemberType>(
      API_ROUTES.INVITE_TO_ALBUM(albumId),
      { email, name, role },
    );
    return response.data;
  }

  static async getAlbumMembers(albumId: number): Promise<AlbumMemberType[]> {
    const response = await ApiService.get<AlbumMembersResponse>(
      API_ROUTES.ALBUM_MEMBERS(albumId),
    );
    return response.data.members;
  }

  static async searchAlbumCollaborators(
    albumId: number,
    query: string,
  ): Promise<AlbumCollaboratorSuggestion[]> {
    const response = await ApiService.get<AlbumCollaboratorSuggestionsResponse>(
      API_ROUTES.ALBUM_COLLABORATOR_SUGGESTIONS(albumId),
      { q: query },
    );
    return response.data.suggestions;
  }

  static async getAlbumInviteInfo(token: string): Promise<AlbumInviteInfo> {
    const response = await ApiService.get<AlbumInviteInfoRaw>(
      API_ROUTES.ALBUM_INVITE_INFO(token),
    );
    return mapInviteInfo(response.data);
  }

  static async acceptAlbumInvite(token: string): Promise<AlbumInviteInfo> {
    const response = await ApiService.post<AlbumInviteInfoRaw>(
      API_ROUTES.ALBUM_INVITE_ACCEPT(token),
    );
    return mapInviteInfo(response.data);
  }

  static async declineAlbumInvite(token: string): Promise<AlbumInviteInfo> {
    const response = await ApiService.post<AlbumInviteInfoRaw>(
      API_ROUTES.ALBUM_INVITE_DECLINE(token),
    );
    return mapInviteInfo(response.data);
  }
}

export { AlbumInviteController };
